import { useI18n } from '../../lib/i18n'

export function NewItemDot() {
  const { t } = useI18n()
  return <span className="dash-unread-dot dash-unread-dot--row" role="img" aria-label={t('nav.newItems')} title={t('nav.newItems')} />
}
